// imports
import LazyLoad from "vanilla-lazyload";
const Flickity = require("flickity");
require("flickity-hash");
// require("fizzy-ui-utils");
import "./components/navigation.js";
import "./components/contact-modal.js";
import GLightbox from "glightbox";
var body = document.querySelector("body");
var html = document.querySelector("html");
const $ = require("jquery");
var Accordion = require("vanilla-js-accordion");

setTimeout(function () {
  body.classList.add("ready");
}, 100);
setTimeout(function () {
  document.querySelector("#loading").remove();
}, 350);

//lazy load options
const lazyLoadOptions = {};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);
pageLazyLoad.update();

const utils = window.fizzyUIUtils;

let lastScrollPosition = 0;
window.addEventListener("scroll", () => {
  const scrollPosition = window.scrollY;

  if (scrollPosition > 50) {
    document.body.classList.add("scrolled");
  } else {
    document.body.classList.remove("scrolled");
  }

  if (scrollPosition > lastScrollPosition) {
    document.body.classList.remove("scroll-up");
    document.body.classList.add("scroll-down");
  } else {
    document.body.classList.remove("scroll-down");
    document.body.classList.add("scroll-up");
  }

  lastScrollPosition = scrollPosition;
});

var productCarousel = document.querySelectorAll(".product-carousel");
if (productCarousel) {
  productCarousel.forEach((i) => {
    let flkty = new Flickity(i, {
      draggable: true,
      prevNextButtons: true,
      wrapAround: false,
      contain: false,
      cellAlign: "left",

      pauseAutoPlayOnHover: false,
      pageDots: true,
      arrowShape: {
        x0: 20,
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 30,
        x3: 30,
      },
    });

    window.addEventListener("resize", function () {
      flkty.resize();
    }); // 200 milliseconds debounce delay
  });
}
var reviewCarousel = document.querySelectorAll(".ti-reviews-container-wrapper");
if (reviewCarousel) {
  reviewCarousel.forEach((i) => {
    let flkty = new Flickity(i, {
      draggable: true,
      prevNextButtons: false,
      wrapAround: false,
      contain: false,
      cellAlign: "left",
      pauseAutoPlayOnHover: false,
      pageDots: true,
      arrowShape: {
        x0: 20,
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 30,
        x3: 30,
      },
    });
  });
}

var productGallery = document.querySelectorAll(".product-gallery");
if (productGallery) {
  productGallery.forEach((i) => {
    let flkty = new Flickity(i, {
      draggable: true,
      prevNextButtons: true,
      wrapAround: false,
      hash: true,
      contain: true,
      pageDots: false,
      arrowShape: {
        x0: 20,
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 30,
        x3: 30,
      },
    });
  });
}

const lightbox = GLightbox({
  touchNavigation: true,
  loop: false,
  autoplayVideos: true,
});

$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
  pageLazyLoad.update();
  const elSelect = document.querySelector(
    ".sf-field-taxonomy-product-category select"
  );
  if (taxSearch) {
    hideOptionsNotInArray(elSelect);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Check if URL has a query string
  if (window.location.search) {
    // Get the tours-section element
    var section = document.querySelector(".tours-section");

    // Check if the section exists
    if (section) {
      // Use setTimeout to delay the action just a bit to allow for everything to fully load
      setTimeout(function () {
        // Scroll to the section
        window.scrollTo({
          top: section.getBoundingClientRect().top + window.scrollY - 80, // offset by 80px
          behavior: "smooth",
        });
      }, 100); // Adjust delay time as necessary
    }
  }
});

var kayakAccordionsccordions = document.querySelectorAll(".kayak-accordion");
var kAccordion = function () {
  kayakAccordionsccordions.forEach((i) => {
    let inAccordion = new Accordion(i, {
      item: ".expandable-section",
      target: ".target",
      control: ".target", // in this case the target is also acting as the control
      panel: ".panel",
      allowMultiple: false,
      attribute: "data-status",
      expanded: "tab-open",
      contracted: "tab-closed",
      prefix: "accordion-",
      transition: "height .35s",
      setFocus: "none", // options: none, item, panel, target, control, first
      hashEnabled: true, // use hash in URL to open accordion item
    });
  });
};

if (kayakAccordionsccordions) {
  kAccordion();
}

var galleryCarousel = document.querySelectorAll(".image-gallery");
if (galleryCarousel) {
  galleryCarousel.forEach((i) => {
    let flkty = new Flickity(i, {
      draggable: true,
      prevNextButtons: false,
      wrapAround: false,
      contain: true,
      pageDots: true,
      cellAlign: "left",
    });

    flkty.on("dragStart", function () {
      document.querySelectorAll("a.gallery-slide").forEach((i) => {
        i.style.pointerEvents = "none";
      });
    });
    flkty.on("dragEnd", function () {
      document.querySelectorAll("a.gallery-slide").forEach((i) => {
        i.style.pointerEvents = "all";
      });
    });
  });
}

$(document.body).on("added_to_cart removed_from_cart", function () {
  $.ajax({
    url: wc_add_to_cart_params.ajax_url,
    data: {
      action: "get_cart_count",
    },
    success: function (response) {
      $("#cart-count").text(response);
    },
  });
});

$("div.woocommerce").on("click", 'input[name="update_cart"]', function () {
  // Trigger an AJAX post request to update the cart count.
  $.post(
    wc_add_to_cart_params.ajax_url,
    { action: "update_cart_count" },
    function (response) {
      // Update the cart count.
      $("#cart-count").text(response);
    }
  );
});

window.addEventListener("resize", function () {
  var windowWidth = window.innerWidth;

  // Get the position you want for your element.
  var newPositionLeft = windowWidth * 0.5 - 645; // Example: 10% from the left
  // Apply new position to the element.
  var elements = document.getElementsByClassName("left-side");
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.left = newPositionLeft + "px";
  }
});

// Check if the element with id "show-filters" exists before adding the event listener
var showFiltersElement = document.getElementById("show-filters");
if (showFiltersElement) {
  showFiltersElement.addEventListener("click", function () {
    // Find the element with the id "filters"
    var filtersElement = document.getElementById("filters");

    // Toggle the display property
    if (
      filtersElement.style.display === "none" ||
      filtersElement.style.display === ""
    ) {
      filtersElement.style.display = "block";
    } else {
      filtersElement.style.display = "none";
    }

    // Toggle the class "filters-open" on the original element
    this.classList.toggle("filters-open");
  });
}